var _path, _circle, _circle2, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyepatchLight = function SvgEyepatchLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 44,
    viewBox: "0 0 90 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.833 23.3838C32.833 24.6357 33.9254 25.7284 35.3719 25.7284C36.8185 25.7284 37.9109 24.6357 37.9109 23.3838H39.4394C39.4394 25.5659 37.574 27.257 35.3719 27.257C33.1698 27.257 31.3044 25.5659 31.3044 23.3838H32.833Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.94307,
    transform: "matrix(-1 0 0 1 16.5246 17.9431)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.94307,
    transform: "matrix(-1 0 0 1 54.22 17.9431)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0815 18.378C24.0815 21.6917 21.3953 24.378 18.0815 24.378C12.5815 24.378 10.5815 20.1917 10.5815 16.878C10.5815 12.5656 14.7678 14.378 18.0815 14.378C21.3953 14.378 24.0815 15.0643 24.0815 18.378Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58154 1C14.0815 21.6667 39.0815 50 89.0815 41",
    stroke: "white",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyepatchLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyepatch_light.56aa3fde.svg";
export { ForwardRef as ReactComponent };